/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MoneyRaisedContainer_app$ref: FragmentReference;
export type MoneyRaisedContainer_app = {|
  +moneyRaised: ?number,
  +dollarsPerDayRate: ?number,
  +$refType: MoneyRaisedContainer_app$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "MoneyRaisedContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "moneyRaised",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "dollarsPerDayRate",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8d58b1350b6477d8ee290add8e1d271f';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/MoneyRaised/__generated__/MoneyRaisedContainer_app.graphql.js